import { ActionBase } from '../../../../core/store/action/ActionBase';

export function addType<TModel>(module: string, type: { new(): TModel;}):string
{
  return `[${module}] Add ${(type as any).$typeName}`;
}

export class AddAction<TModel> implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }, public payload: { model: TModel }) {
    this.type = addType(module, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/actions/AddAction.ts